module.exports = __webpack_public_path__ + "assets/img/like-active.31d4a944.svg";